import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import JustifyContentUI from './ui';

const JustifyContentControl = props => {
  return createElement(JustifyContentUI, _extends({}, props, {
    isToolbar: false
  }));
};

const JustifyToolbar = props => {
  return createElement(JustifyContentUI, _extends({}, props, {
    isToolbar: true
  }));
};
/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/justify-content-control/README.md
 */


export { JustifyContentControl, JustifyToolbar };
//# sourceMappingURL=index.js.map